import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerWorkorderTitleComponent } from '../drawers/drawer-workorder-title/drawer-workorder-title.component';
import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EmployeesRepository } from 'src/employees/employees.repository';
import { EmployeesQuery } from 'src/employees/state/employees.query';
import { EmployeeDto } from 'src/api';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { WorkOrdersRepository } from '../workorders.repository';
import { DrawerWorkorderActionsComponent } from '../drawers/drawer-workorder-actions/drawer-workorder-actions.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorder-not-mine',
  standalone: true,
  templateUrl: './workorder-not-mine.component.html',
  styleUrls: ['./workorder-not-mine.component.scss'],
  imports: [
    CommonModule,
    DrawerWorkorderTitleComponent,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    DrawerWorkorderActionsComponent,
    TranslateModule,
  ],
})
export class WorkorderNotMineComponent implements OnInit {
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  searchTerm$: Observable<string> = this.searchTerm.asObservable();

  supervisors$: Observable<EmployeeDto[]>;
  suggestedSupervisorControl = new FormControl<EmployeeDto>({});

  get workOrder() {
    return this.data.workOrder;
  }

  constructor(
    public drawerRef: MtxDrawerRef<WorkorderNotMineComponent>,
    @Inject(MTX_DRAWER_DATA) public data: any,
    private employeesRepository: EmployeesRepository,
    private employeesQuery: EmployeesQuery,
    private workOrdersRepository: WorkOrdersRepository
  ) {
    this.supervisors$ = combineLatest([this.employeesQuery.selectAll(), this.searchTerm$]).pipe(
      map(([employees, searchTerm]) => {
        if (searchTerm) {
          var supervisors = employees.filter((e) => e.role == 'Supervisor');
          supervisors = supervisors.filter((x) => x.name?.toLowerCase().includes(searchTerm.toLocaleLowerCase()));

          return supervisors;
        }

        return [];
      })
    );
  }

  ngOnInit(): void {
    this.employeesRepository.loadEmployees();
  }

  confirm() {
    const suggestedSupervisorId = this.suggestedSupervisorControl.value
      ? this.suggestedSupervisorControl.value.id
      : null;

    this.workOrdersRepository.setWorkOrderAsNotMine(this.workOrder.id as number, suggestedSupervisorId as number);

    this.drawerRef.dismiss();
  }

  close() {
    this.drawerRef.dismiss();
  }

  updateSearchTerm(searchTerm: string) {
    this.searchTerm.next(searchTerm);
  }

  displayEmployee(employee: EmployeeDto): string {
    return employee && employee.name ? employee.name : '';
  }
}
